import { useState, useEffect, Fragment } from "react";
import Config from "../../Config";

import InputText from "../../helpers/InputText";
import InputDecimal from "../../helpers/InputDecimal";
import InputTextArea from "../../helpers/InputTextArea";
import InputChecbox from "../../helpers/InputCheckbox";

import PlTitle from "../../elements/PlTitle";

import back from "../../back.png";
import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputSearchKid from "../../helpers/InputSearchKid";

function KidPersonNew(props)
{


       const [errTab, setErrTab] = useState([]);  //z info od serwera..

       const [emps, setEmps] = useState(null); //pracownicy..

       var defId = '_x_';
       if(props.id != undefined) defId = props.id;

       const [row, setRowX] = useState({
            p_dziecko_id: defId,
            imie:  "",
            nazwisko:  "",
            stopien_pokrewienstwa:  "",
            numer_dowodu:  "",
         
        });
        var tmpRow = row;


        const [checked, setChecked] = useState(false);
        const handleChange = () => {
            setChecked(!checked);
          };


        const valChecker = (fields) => {

            var allValid = true;
    
                  
            console.log(JSON.stringify(fields) );

            Object.entries(fields).forEach(function(entry) {
    
                var xKey    = entry[0];
                var xValue  = entry[1];                    

                var xValidName = xKey + "_valid";
    
                if(fields[xValidName] == false)
                {
                    allValid = false;
                    console.log("Error field: " + xKey);
                }
                
              });
            
              return allValid;
    
        }
    

        const valChangeListener = (filedName, val, correct, msg) => {         
            //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg); 
            var tabCheck = filedName.split('@');
            if(tabCheck.length == 2)
            {
                var tabName = tabCheck[0];
                var tabInx  = tabCheck[1];
                var tRef = row[tabName];
                if(correct)tRef[tabInx] = val;
                if(!correct)tRef[tabInx] = "";

                tmpRow[tabName] = tRef;     
                setRowX(  JSON.parse(JSON.stringify(tmpRow)) );  
    
                //setRowX( {...row, [tabName]:tRef } );   
                return;
            }
    
          
            tmpRow[filedName] = val;
            tmpRow[filedName+"_valid"] = correct;         
            setRowX(  JSON.parse(JSON.stringify(tmpRow)) );            
            //setRowX( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );      
        }   


        
        const kidSelected = (p_dziecko_id) => {    
            setRowX( {...row, ['p_dziecko_id']:p_dziecko_id  } );
        }

    
    
        const goNextNew = () => {
            console.log("goNext");
            saveData();
        }
    
        const saveData = () => {


 

            if(!valChecker(row))
            {
                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_gocorrect  ,  "ok"  ,null); 
                return;
            }
        
    
            props.mainView.setProgress(-2);
    
            var req = row;
    
            fetch( Config.url + '/rest_v1_kids,person_add', {
                method: 'POST', 
                body: JSON.stringify(req), 
                headers: {
                    'Content-Type': 'application/json',                    
                    'X-Api-Key': props.userData.apiKey,
                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                    '_sec_key_': Config.genXKey() ,
                }
             })
             .then(res => res.json() )
             .then(res => {             
                        
                        props.mainView.setProgress(-1);
    
                        if(res._sys_ == undefined)
                        {
                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                        }else
                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                        {
                           // props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                           setErrTab(res.result);
                        }else
                        if(res.status != undefined && res.status == "OK")
                        {
                            props.mainView.showDialog( "Sukces",  "Osoba została dodana", "ok" , null);                         
                            props.onBack(res.result);
                        }else
                        {
                            props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                        }
                       
             } )
             .catch(err => {   
                        props.mainView.setProgress(-1);       
                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
             });
                       
    
             return false;
    
        }
     


    
       
            


        return (
                 <div className="view_content">

                        <img src={back} onClick={props.onBack} className="back_img" title="wstecz"/>

                        <h3 className="calColor">Nowa osoba upoważnione do odbioru dziecka {props.title}</h3>
                    
                        
                        <form className="eForm bg_center">

                                     
                                      {
                                                props.id == undefined &&
                                                <Fragment>
                                                  <div className="form_tab_title">Dziecko:</div>
                                                  <div className="form_tab">
                                                     <div className="form_control">
                                                        <div className="fieldName">Dziecko</div>
                                                        <InputSearchKid archiwalne='0'  mainView={props.mainView} userData={props.userData}   err={errTab} kidSelected={kidSelected} valChange={valChangeListener} goNext={goNextNew} name="fraza" placeholder={"Dziecko: "} className=' w250 ' req='1' firstUp="1" />
                                                    </div>
                                                  </div>
                                                </Fragment>
                                      }


                                    <div className="form_tab_title">Informacje o osobie, która będzie odbierała dziecko:</div>
                                    <div className="form_tab">
 

                                         


                                            <div className="form_control">
                                                <div className="fieldName">Imię*</div>
                                                <InputTextAlpha   userData={props.userData} value={row.imie} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="imie" placeholder={"Imię:"} className=' w200 ' req='1' firstUp="1" />
                                            </div>
 
                                           <div className="form_control">
                                                <div className="fieldName">Nazwisko*</div>
                                                <InputTextAlpha   userData={props.userData} value={row.nazwisko} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="nazwisko" placeholder={"Nazwisko:"} className=' w200 ' req='1' firstUp="1" />
                                            </div>


                                           <div className="form_split"></div>

                                            <div className="form_control">
                                                <div className="fieldName">Stopień pokrewieństwa (babca, ciocia, znajoma)*</div>
                                                <InputText  userData={props.userData} value={row.stopien_pokrewienstwa} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="stopien_pokrewienstwa" placeholder={"Stopień pokrewieństwa:"} className=' w200 ' req='1' firstUp="1" />
                                            </div>


                                             <div className="form_control">
                                                <div className="fieldName">Nr dowodu / dokumentu*</div>
                                                <InputText   userData={props.userData} value={row.numer_dowodu} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="numer_dowodu" placeholder={"Nr dowodu:"} className=' w100 ' req='1' firstUp="1" />
                                            </div>

                                    </div>

 
 



                                    <div className="form_split"></div>

                                    <div className="form_btn">
                                            <div className="btn" onClick={saveData}>dodaj</div>
                                            &nbsp;&nbsp;
                                            <div className="btn" onClick={props.onBack}    > anuluj</div>
                                    </div>

                        </form>

                </div>
        )
}


export default KidPersonNew;